import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TerminalRunsModule } from '../terminal-runs/terminal-runs.module';
import { UnassignedTasksComponent } from '../../components/unassigned-tasks/unassigned-tasks.component';
import { SharedModule } from '../shared-module/shared.module';
import { UnassingedTaskConfirmationDialogComponent } from 'src/app/components/unassigned-tasks/unassingned-task-confirmation-dialog/unassingned-task-confirmation-dialog.component';
import { MatCardModule } from '@angular/material/card';

const routes: Route[] = [{
  path: 'unassignedTasks',
  component: UnassignedTasksComponent,
  children: [
    {path: 'create', component: UnassignedTasksComponent, outlet: 'side'}
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatExpansionModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    TerminalRunsModule,
    MatCardModule,
    SharedModule,
    FontAwesomeModule
  ],
  declarations: [
    UnassingedTaskConfirmationDialogComponent,
    UnassignedTasksComponent],
  exports:[UnassignedTasksComponent]
})
export class UnassignedTasksModule { }
